export default __webpack_public_path__ + "static/media/cardimage4.e248f5cd.png";